<template>
    <v-container>
        <v-row justify="center">
            <v-col cols=12>
                <v-card class="display-2 text-center pa-5">
                    Gas Stations
                </v-card>
            </v-col>
            <v-col cols=12 sm=5>
                <canvas id="frequency"></canvas>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import Chart from "chart.js"

export default {
    // Prevent the user from accessing the dashboard if they are not logged in.
    beforeRouteEnter (to, from, next) {
        next(vm => {
            if (vm.$store.state.token.length < 1) {            
                next("/login");
            } else {
                next();
            }
        })
    },
    props: ["carId"],
    data() {
        return {
            showChart: false
        }
    },
    computed: {
         car() {           
            return this.$store.getters.getSpecificCar(this.carId);
        },
        gasStations() {
            let map = {};
            let names = [];

            // Get all of the gas station names
            this.car.mpg.forEach(item => {
                if (names.includes(item.gasStation.name) == false) {
                    names.push(item.gasStation.name);
                }
            });

            // Get the frequency of each gas station
            for (let i = 0; i < names.length; i++) {
                map[names[i]] = this.car.mpg.filter(item => item.gasStation.name === names[i]).length;
            }

            return map;
        }
    },
    mounted: function () {
        // To use the vue instance
        let self = this;

        // TODO Update the chart to reflect the different datasets.

        // Chart setup
        var ctx = document.getElementById('frequency').getContext('2d');
        new Chart(ctx, {
            type: 'bar',
            data: {
                labels: Object.keys(self.gasStations),
                datasets: [{
                    label: 'Gas Station',
                    data: Object.values(self.gasStations),
                    backgroundColor: [
                        'rgba(255, 99, 132, 0.2)',
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 206, 86, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(153, 102, 255, 0.2)',
                        'rgba(255, 159, 64, 0.2)'
                    ],
                    borderColor: [
                        'rgba(255, 99, 132, 1)',
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 206, 86, 1)',
                        'rgba(75, 192, 192, 1)',
                        'rgba(153, 102, 255, 1)',
                        'rgba(255, 159, 64, 1)'
                    ],
                    borderWidth: 1
                }]
            },
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            }
        });
    }
}
</script>